export class KPISApi {
  constructor(Client) {
    this.Client = Client;
  }

  all = () => {
    return this.Client.get('/kpis').then(response => {
      if (!response || !response.data) return false;
      return response.data;
    });
  };
}

export default KPISApi;
